document.addEventListener('DOMContentLoaded', () => {
    const openingHoursBlocks = document.querySelectorAll('.opening-hours');

    if (openingHoursBlocks.length === 0) {
        return;
    }

    /**
     * Parses the content attribute of a day element to extract opening hours.
     * @param {string} content - The content string, e.g., "Mo 08:00-12:00,13:30-18:30".
     * @returns {object|null} An object with dayCode and an array of time intervals, or null if invalid.
     */
    function parseDayIntervals(content) {
        if (!content || content.trim() === '' || content.trim().toLowerCase().endsWith("closed")) {
            return { closed: true, intervals: [] };
        }

        const parts = content.trim().match(/^([A-Za-z]{2})\s(.+)$/);
        if (!parts) {
            return null;
        }

        const dayCode = parts[1];
        const timeRangesStr = parts[2];

        const intervals = timeRangesStr.split(',').map(range => {
            const times = range.trim().split('-');
            if (times.length !== 2) {
                return null;
            }
            // The schema can contain a timezone offset (e.g., "08:00+02:00").
            // We only need the time part, as the offset is handled separately
            // from the `data-offset` attribute.
            const startTime = times[0].substring(0, 5);
            const endTime = times[1].substring(0, 5);
            return { startTime: startTime, endTime: endTime };
        }).filter(Boolean); // Remove nulls from invalid ranges

        if (intervals.length === 0) {
            return { closed: true, intervals: [] };
        }

        return {
            dayCode: dayCode,
            intervals: intervals,
            closed: false,
        };
    }

    /**
     * Checks if a location is currently open based on its intervals and timezone offset.
     * @param {object} dayData - The parsed data for the current day.
     * @param {Date} now - The current Date object.
     * @param {string} isoDate - Today's date in YYYY-MM-DD format.
     * @param {string} offsetString - The timezone offset string, e.g., "+02:00".
     * @returns {boolean} True if currently open, false otherwise.
     */
    function isCurrentlyOpen(dayData, now, isoDate, offsetString) {
        if (dayData.closed || !offsetString) {
            return false;
        }

        const dayMap = { 'Su': 0, 'Mo': 1, 'Tu': 2, 'We': 3, 'Th': 4, 'Fr': 5, 'Sa': 6 };
        if (dayMap[dayData.dayCode] !== now.getDay()) {
            return false;
        }

        for (const interval of dayData.intervals) {
            try {
                const start = new Date(`${isoDate}T${interval.startTime}:00${offsetString}`);
                const end = new Date(`${isoDate}T${interval.endTime}:00${offsetString}`);

                // Handle overnight hours
                if (end.getTime() < start.getTime()) {
                    end.setDate(end.getDate() + 1);
                }

                if (now.getTime() >= start.getTime() && now.getTime() < end.getTime()) {
                    return true;
                }
            } catch (e) {
                // Invalid date string, skip this interval
                console.error('Error parsing date for interval', interval, e);
                continue;
            }
        }

        return false;
    }

    /**
     * Updates the displayed time to the user's local timezone.
     * @param {HTMLElement} dayElement - The <li> element for the day.
     * @param {object} dayData - The parsed data for the day.
     * @param {string} isoDate - Today's date in YYYY-MM-DD format.
     * @param {string} offsetString - The timezone offset string, e.g., "+02:00".
     */
    function updateDisplayTime(dayElement, dayData, isoDate, offsetString) {
        if (dayData.closed || !offsetString) {
            return;
        }

        const timeSpan = dayElement.querySelector('.user-time');
        if (!timeSpan) return;

        const displayRanges = dayData.intervals.map(interval => {
            try {
                const startDateTime = new Date(`${isoDate}T${interval.startTime}:00${offsetString}`);
                const endDateTime = new Date(`${isoDate}T${interval.endTime}:00${offsetString}`);

                const options = { hour: '2-digit', minute: '2-digit', hour12: false };
                const userStartTime = startDateTime.toLocaleTimeString([], options);
                const userEndTime = endDateTime.toLocaleTimeString([], options);

                return `${userStartTime} - ${userEndTime}`;
            } catch (e) {
                // Fallback to original string if date parsing fails
                console.error('Error converting time for interval', interval, e);
                return `${interval.startTime} - ${interval.endTime}`;
            }
        });

        timeSpan.textContent = displayRanges.join(', ');
    }

    /**
     * Processes a single opening hours block.
     * @param {HTMLElement} block - The .opening-hours element.
     */
    function processOpeningHoursBlock(block) {
        const list = block.querySelector('.opening-hours__days');
        if (!list) return;

        const offsetString = list.dataset.offset;
        if (!offsetString) {
            // If no timezone offset is provided, we can't do timezone conversion or check open status.
            return;
        }

        const dayElements = list.querySelectorAll('.opening-hours__day');
        const now = new Date();
        const isoDate = now.toISOString().split('T')[0];

        dayElements.forEach(dayElement => {
            const dayContent = dayElement.getAttribute('content');
            if (!dayContent) return;

            const dayData = parseDayIntervals(dayContent);
            if (!dayData) return;

            const isOpen = isCurrentlyOpen(dayData, now, isoDate, offsetString);
            dayElement.classList.add(`opening-hours__day--${isOpen ? '1' : '0'}`);

            updateDisplayTime(dayElement, dayData, isoDate, offsetString);
        });
    }

    openingHoursBlocks.forEach(processOpeningHoursBlock);
});


document.addEventListener('DOMContentLoaded', () => {
    const services = document.querySelectorAll('.h-services');
    if (services) {
        services.forEach((service) => {
            const listItems = service.querySelectorAll('.h-service');
            const toggleButton = service.querySelector('.h-services__toggle');

            if (toggleButton) {
                toggleButton.addEventListener('click', () => {
                    listItems.forEach(item => {
                        item.classList.remove('hidden-item');
                    });
                    toggleButton.style.display = 'none';
                });
            }
        });
    }
});
